module.exports = __webpack_public_path__ + "img/073601.685edcef.png";